export const productIdFromCardKey = (key: unknown): string | undefined => {
  if (key === undefined || key === null) return undefined

  return String(key).split(':')[0]
}
